var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34443_113872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 3.75C5.83203 3.75 2.2737 6.34167 0.832031 10C2.2737 13.6583 5.83203 16.25 9.9987 16.25C14.1654 16.25 17.7237 13.6583 19.1654 10C17.7237 6.34167 14.1654 3.75 9.9987 3.75ZM9.9987 14.1667C7.6987 14.1667 5.83203 12.3 5.83203 10C5.83203 7.7 7.6987 5.83333 9.9987 5.83333C12.2987 5.83333 14.1654 7.7 14.1654 10C14.1654 12.3 12.2987 14.1667 9.9987 14.1667ZM9.9987 7.5C8.61536 7.5 7.4987 8.61667 7.4987 10C7.4987 11.3833 8.61536 12.5 9.9987 12.5C11.382 12.5 12.4987 11.3833 12.4987 10C12.4987 8.61667 11.382 7.5 9.9987 7.5Z",
    fill: "#51B15C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34443_113872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewIcon);
export default __webpack_public_path__ + "static/media/previewIcon.f315ff101aec2277f40403fd2389c6dc.svg";
export { ForwardRef as ReactComponent };